import { setCurrentTimeOverride } from "@sa-nu/shared-utils/date";

import { publicEnv } from "./public-env";

// ブラウザ上で使う環境判定
// NOTE: These must be functions (not module-level constants) because on the client,
// `publicEnv` reads from `window.publicEnv` which is injected by an inline script.
// Module-level evaluation can race with that script, causing the value to be undefined.
// 注入 script が出ない文書 (Next の `__next_error__` シェル) でもここは走る。参照して throw すると
// 404 画面が error.tsx の 500 画面に差し替わるので、env 不明時は全判定 false に倒す。
export const isPublicDevelopmentEnv = () => publicEnv?.PUBLIC_APP_ENV === "dev";

// dev環境でのみ getCurrentTime() の時刻を上書き（クライアントサイド用）
// RootProvider など描画前に呼び出すこと
export const initClientTimeOverride = () => {
  if (isPublicDevelopmentEnv() && publicEnv?.OVERRIDE_CURRENT_TIME) {
    setCurrentTimeOverride(publicEnv.OVERRIDE_CURRENT_TIME);
  }
};
export const isPublicPreviewEnv = () =>
  (["feat", "integ"] as string[]).includes(publicEnv?.PUBLIC_APP_ENV ?? "");
export const isPublicFeaturePreviewEnv = () =>
  publicEnv?.PUBLIC_APP_ENV === "feat";
export const isPublicIntegrationPreviewEnv = () =>
  publicEnv?.PUBLIC_APP_ENV === "integ";
export const isPublicProductionEnv = () => publicEnv?.PUBLIC_APP_ENV === "prd";
